export default {
    loadData : async function() {
        let listData = require('../assets/weapons/datas/weaponAndTypeDatas.json');
        let potionData = require('../assets/weapons/datas/potionIconType.json');
        potionData.forEach(p => {
            listData.push(p);
        });
        return listData;
    }
}